@if (
  addressForm &&
  !useMailingAddressTemplate &&
  !useStreetAddressTemplate &&
  requiredFields
) {
  <div class="row" [formGroup]="addressForm">
    <div
      [ngClass]="{
        'col-12': defaultLayout === 'vertical',
        'col-12 col-lg-3': defaultLayout === 'horizontal'
      }"
    >
      <label
        for="address1"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('address1') || false"
        >Address</label
      >
      <input
        type="text"
        class="form-control"
        id="address1"
        formControlName="address1"
      />
    </div>
    <div
      [ngClass]="{
        'col-12': defaultLayout === 'vertical',
        'col-12 col-lg-3': defaultLayout === 'horizontal'
      }"
    >
      <label
        for="address2"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('address2') || false"
        >Address 2</label
      >
      <input
        type="text"
        class="form-control"
        id="address2"
        formControlName="address2"
      />
    </div>
    <div
      [ngClass]="{
        'col-4': defaultLayout === 'vertical',
        'col-4 col-lg-2': defaultLayout === 'horizontal'
      }"
    >
      <label
        for="city"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('city') || false"
        >City</label
      >
      <input
        type="text"
        class="form-control"
        id="city"
        formControlName="city"
      />
    </div>
    <div
      [ngClass]="{
        'col-4': defaultLayout === 'vertical',
        'col-4 col-lg-2': defaultLayout === 'horizontal'
      }"
    >
      <label
        for="state"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('state') || false"
        >{{
          LocalizationInfo && LocalizationInfo.territory
            ? LocalizationInfo.territory.label
            : 'State'
        }}</label
      >
      <app-select-dropdown
        [options]="SubNationalDivisions"
        [control]="addressForm.controls['state']"
        [dropdownId]="'addressStateDropdown'"
        [placeholder]="''"
      ></app-select-dropdown>
    </div>
    <div
      [ngClass]="{
        'col-4': defaultLayout === 'vertical',
        'col-4 col-lg-2': defaultLayout === 'horizontal'
      }"
    >
      <label
        for="zip"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('zip') || false"
        >{{
          LocalizationInfo && LocalizationInfo.postalCode
            ? LocalizationInfo.postalCode.label
            : 'Zip'
        }}</label
      >
      <input
        type="text"
        class="form-control"
        id="zip"
        placeholder="{{
          LocalizationInfo && LocalizationInfo.postalCode.format
            ? LocalizationInfo.postalCode.format
            : ''
        }}"
        [inputMask]="zipMask"
        formControlName="zip"
      />
    </div>
  </div>
}

@if (addressForm && isMailing && useMailingAddressTemplate) {
  <div class="row" [formGroup]="addressForm">
    <div class="col-12 col-lg-3">
      <label
        for="address1"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('address1') || false"
        >Mailing Address</label
      >
      <input
        type="text"
        class="form-control"
        id="address1"
        formControlName="address1"
      />
    </div>
    <div class="col-12 col-lg-3">
      <label
        for="address2"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('address2') || false"
        >Mailing Address 2</label
      >
      <input
        type="text"
        class="form-control"
        id="address2"
        formControlName="address2"
      />
    </div>
    <div class="col-12 col-lg-2">
      <label
        for="city"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('city') || false"
        >City</label
      >
      <input
        type="text"
        class="form-control"
        id="city"
        formControlName="city"
      />
    </div>
    <div class="col-12 col-lg-2">
      <label
        for="state"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('state') || false"
        >{{
          LocalizationInfo && LocalizationInfo.territory
            ? LocalizationInfo.territory.label
            : 'State'
        }}</label
      >
      <app-select-dropdown
        [options]="SubNationalDivisions"
        [control]="addressForm.controls['state']"
        [dropdownId]="'mailingStateDropdown'"
        [placeholder]="''"
      ></app-select-dropdown>
    </div>
    <div class="col-12 col-lg-2">
      <label
        for="zip"
        class="form-label"
        [requiredAsterisk]="requiredFields.get('zip') || false"
        >{{
          LocalizationInfo && LocalizationInfo.postalCode
            ? LocalizationInfo.postalCode.label
            : 'Zip'
        }}</label
      >
      <input
        type="text"
        class="form-control"
        id="zip"
        placeholder="{{
          LocalizationInfo && LocalizationInfo.postalCode.format
            ? LocalizationInfo.postalCode.format
            : ''
        }}"
        [inputMask]="zipMask"
        formControlName="zip"
      />
    </div>
  </div>
}

@if (addressForm && isStreet && useStreetAddressTemplate) {
  <div class="row" [formGroup]="addressForm">
    <div class="col-12 col-lg-3">
      <label for="address1" class="form-label"
        >Street Address<span class="required-field-asterisk">*</span></label
      >
      <input
        type="text"
        class="form-control"
        id="address1"
        formControlName="address1"
      />
    </div>
    <div class="col-12 col-lg-3">
      <label for="address2" class="form-label">Street Address 2</label>
      <input
        type="text"
        class="form-control"
        id="address2"
        formControlName="address2"
      />
    </div>
    <div class="col-12 col-lg-2">
      <label for="city" class="form-label"
        >City<span class="required-field-asterisk">*</span></label
      >
      <input
        type="text"
        class="form-control"
        id="city"
        formControlName="city"
      />
    </div>
    <div class="col-12 col-lg-2">
      <label for="state" class="form-label"
        >{{
          LocalizationInfo && LocalizationInfo.territory
            ? LocalizationInfo.territory.label
            : 'State'
        }}<span class="required-field-asterisk">*</span></label
      >
      <app-select-dropdown
        [options]="SubNationalDivisions"
        [control]="addressForm.controls['state']"
        [dropdownId]="'streetStateDropdown'"
        [placeholder]="''"
      ></app-select-dropdown>
    </div>
    <div class="col-12 col-lg-2">
      <label for="zip" class="form-label"
        >{{
          LocalizationInfo && LocalizationInfo.postalCode
            ? LocalizationInfo.postalCode.label
            : 'Zip'
        }}<span class="required-field-asterisk">*</span></label
      >
      <input
        type="text"
        class="form-control"
        id="zip"
        placeholder="{{
          LocalizationInfo && LocalizationInfo.postalCode.format
            ? LocalizationInfo.postalCode.format
            : ''
        }}"
        [inputMask]="zipMask"
        formControlName="zip"
      />
    </div>
  </div>
}
